module.exports = __webpack_public_path__ + "static/media/right-blue-arrow.ba0f06cd.svg";